import { Box, type BoxProps } from '@chakra-ui/react';

export type UiBoxProps = BoxProps;

export const UiBox = Box;
